<div class="col-md-12 "  id ="submenu">
  <ul class="nav " >
	<li class="nav-item">
		<a routerLink="/acp/{{projectString}}" routerLinkActive="active">&nbsp;Home</a>
	  <!--a href="#" class=" nav-link "> <i class="fa fa-home fa-home"></i>&nbsp;Home</a-->
	</li>
	<li class="nav-item">
		<a routerLink="/acp/{{projectString}}/settings" routerLinkActive="active">Application Settings</a>
	  <!--a class="active nav-link  font-weight-bold text-dark" href="#">Application Settings</a-->
	</li>
	<li class="nav-item">
		<a routerLink="/acp/{{projectString}}/userManagement" routerLinkActive="active">User Management</a>
	  <!--a href="#" class="nav-link">User Management</a-->
	</li>
	<li class="nav-item">
		<a routerLink="/acp/{{projectString}}/documentManagement" routerLinkActive="active">Document Management</a>
	</li>
	<li class="nav-item">
		<a routerLink="/acp/{{projectString}}/latestsearch" routerLinkActive="active">Search</a>
	</li>
  </ul>
</div>